import React from 'react'
import { Link } from 'react-router-dom'
import HR from '../images/hr.svg'
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
    {
      icon: <FaCloud />,
      title: 'Performance Management',
      description: 'Implement effective performance management strategies to evaluate and improve employee performance, driving organizational success.',
    },
    {
      icon: <FaLock />,
      title: 'Training Programs',
      description: 'Customized training programs to enhance employee skills and align with your company’s objectives, improving overall performance and productivity.',
    },
    {
      icon: <FaMobileAlt />,
      title: 'Career Development',
      description: 'Support your employees’ career growth with tailored development plans, fostering a motivated and skilled workforce.',
    },
  
  ];

const EmployeeTraining = () => {
  return (
    <div>
       <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={HR}
        alt="HR Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Employee Training & Development</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert HR Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored HR Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic HR planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
     
      </div>
      </section>

    </div>

    </div>
    </div>
  )
}

export default EmployeeTraining
